export default __webpack_public_path__ + "static/media/buyBestBanner2.e8c615e6.png";